import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — Peopels" },
      { name: "description", content: "How Peopels uses cookies and how to manage your consent." },
    ],
    links: [{ rel: "canonical", href: "/cookies" }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-3xl flex-1 px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-bold">Cookie Policy</h1>
        <p className="mt-4 text-muted-foreground">The Peopels platform is operated by <strong>Ashers Hub Ltd</strong> (company number <strong>17204476</strong>). We use essential cookies to make Peopels work, and (with your consent) analytics cookies to improve it. You can change your consent at any time by clearing your cookies and revisiting the site.</p>
      </main>
      <Footer />
    </div>
  );
}
